.result {
    background-color: var(--white);
    border: 1px solid var(--gray);
    margin-top: var(--spacer-16);
    margin-bottom: var(--spacer-16);
}

.clickable {
    composes: grid from "../../styles/composable/layout.module.css";
    padding: var(--spacer-16);
}

.image {
    grid-column: span 3;
}

.description {
    grid-column: span 9;
}

.title {
    font: var(--font-h-24);
}
